module.exports = __webpack_public_path__ + "img/logo-company.236c769c.png";